<template>
<nav class="dflexr-jcs selector-nav">
  <div class="btn btn-mp-selector"
       v-for="(mp, idx) in pkg.list"
       :key="idx" @click="select_mp(idx)"
       :class="{ 'mp-selected': idx === pkg.active_mp }"
       :mp_idx="idx"
  >
    Market #{{ idx+1 }}
  </div>
</nav>
</template>

<style scoped lang="scss">
@import '../../assets/styles/colors.scss';
  nav {
    color: white;
    padding: 0 1rem;
    gap: 1rem;

    .mp-selected {
      background-color: rgba(0, 230, 248, 0.39);
    }
  }
</style>

<script setup>

import {inject, onUpdated, ref} from "vue";

const pkg = inject('mp_pkg')

function select_mp(idx) {
  pkg.active_mp = idx
}

onUpdated(() => {

})

</script>
